import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


export interface CustomerFeedbackUpdateResponse {
    Comment: string;
    CreatedOn: string;
    Id: string;
    Score: number;
    UpdatedOn: string;
}

export interface ExistingCustomerFeedback {
    feedbackId: string;
    customerId: string;
    eventId: string;
    feedbackComment: string;
    rating: number;
}

export interface FeedbackUpdateItem {
    current: ExistingCustomerFeedback;
    new: {
        customerId: string;
        eventId: string;
        feedbackComment: string;
        rating: number;
    };
}

@Component({
    selector: 'app-feedback-update-action-dialog',
    templateUrl: './feedback-update-action-dialog.component.html',
    styleUrls: ['./feedback-update-action-dialog.component.scss']
})
export class FeedbackUpdateActionDialogComponent {
    currentIndex = 0;
    hasError = false;

    constructor(
        public dialogRef: MatDialogRef<FeedbackUpdateActionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: FeedbackUpdateItem[],
        private _http: HttpClient
    ) { }

    get currentFeedback(): FeedbackUpdateItem | null {
        return this.data && this.currentIndex < this.data.length ? this.data[this.currentIndex] : null;
    }

    async handleCustomerFeedbackUpdate(data: ExistingCustomerFeedback) {
        const body = {
            feedbackComment: data.feedbackComment,
            rating: data.rating
        }
        try {
            return await this._http.put<CustomerFeedbackUpdateResponse>(`core-api/api/v1/events/cutomer-feeback/${data.feedbackId}`, body).toPromise();
        } catch (err) {
            console.error("Error updating feedback:", err);
            this.hasError = true;

            // setTimeout(() => {
            //     this.hasError = false;
            // }, 2000);
        }
    }

    moveToNext(action: 'overwrite' | 'skip') {
        if (this.currentIndex < this.data.length - 1) {
            this.currentIndex++;

        } else {
            this.dialogRef.close({ action });
        }
    }

    async onOverwrite(): Promise<void> {
        const updatedFeedback = await this.handleCustomerFeedbackUpdate({
            feedbackId: this.data[this.currentIndex].current.feedbackId,
            ...this.data[this.currentIndex].new
        });
        if (updatedFeedback) {
            this.moveToNext('overwrite');
        }
    }

    onSkip(): void {
        this.moveToNext('skip');
    }

    onClose(): void {
        this.dialogRef.close({ action: 'close' });
    }

    ngOnInit(): void {
        if (!this.data || this.data.length === 0) {
            this.dialogRef.close({ action: 'no-data' });
        }
    }
}
